import { get } from 'lodash';

import { FIELD_PATHS, URL_PARAM_APPLICANT_ID, URL_PARAM_APPLICATION_ID } from '@funnels/constants';
import { FunnelConfig } from '@funnels/customer-view/src/configs';
import { PAGE_TITLE } from '@funnels/customer-view/src/configs/FunnelTwo/constants';
import { FunnelApplicants } from '@funnels/ui-layouts/customer-view';
import {
  AdditionalEmployments,
  CurrentEmployment,
  EmploymentHistory,
} from '@funnels/ui-layouts/customer-view/Employment';
import { getBrandSpecificBaseURL, getIndexFromId } from '@funnels/utils';

const baseName = `/application/:${URL_PARAM_APPLICATION_ID}/applicant/:${URL_PARAM_APPLICANT_ID}/employment-summary-edit`;

const incomeSummaryUrl = (applicantType: string) =>
  `${getBrandSpecificBaseURL()}/application/:${URL_PARAM_APPLICATION_ID}/income/${applicantType.toLowerCase()}-summary/`;

const employmentSummaryEditConfig: FunnelConfig = {
  baseName,
  entryPoint: () => baseName,
  questions: [
    {
      url: baseName,
      component: ({ applicantIndex }) => <EmploymentHistory applicantIndex={applicantIndex} isFromSummary />,
      target: (values: any, { params }) => {
        const applicationId = params![URL_PARAM_APPLICATION_ID];
        const applicantId = params![URL_PARAM_APPLICANT_ID];
        const applicants = get(values, FIELD_PATHS.APPLICANTS(), []);
        const applicantIndex = getIndexFromId(applicants, applicantId);
        const applicantType = get(values, FIELD_PATHS.APPLICANT_TYPE(applicantIndex));
        return {
          url: `${getBrandSpecificBaseURL()}/application/${applicationId}/applicant/${applicantId}/employment/employment-history/${applicantType.toLowerCase()}-summary`,
          hardRedirect: true,
        };
      },
      pageTitle: PAGE_TITLE.employmentHistory,
    },
    // Employment summary edit flow
    {
      url: `${baseName}/current-employment/`,
      component: (props) => <CurrentEmployment {...props} isFromSummary />,
      target: (values: any, { applicantIndex = 0 }) => {
        const applicantType = get(values, FIELD_PATHS.APPLICANT_TYPE(applicantIndex));
        return { url: incomeSummaryUrl(applicantType), hardRedirect: true };
      },
      pageTitle: PAGE_TITLE.currentEmployment,
    },
    {
      url: `${baseName}/additional-employment/`,
      component: (props) => <AdditionalEmployments {...props} isFromSummary />,
      target: (values: any, { applicantIndex = 0 }) => {
        const applicantType = get(values, FIELD_PATHS.APPLICANT_TYPE(applicantIndex));
        return { url: incomeSummaryUrl(applicantType), hardRedirect: true };
      },
      pageTitle: PAGE_TITLE.additionalEmployment,
    },

    // Income summary edit flow
    {
      url: `${baseName}/additional-income/`,
      component: (props) => <FunnelApplicants.AdditionalIncomes {...props} isFromSummary />,
      target: (values: any, { applicantIndex = 0 }) => {
        const applicantType = get(values, FIELD_PATHS.APPLICANT_TYPE(applicantIndex));
        return { url: incomeSummaryUrl(applicantType), hardRedirect: true };
      },
      pageTitle: PAGE_TITLE.additionalIncome,
    },
  ],
};

export default employmentSummaryEditConfig;
